import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    padding: 20px;
    width: ${(props) => (props.fromSignup ? "70%" : props.maxWidth)};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 600px) {
      ${(props) =>
        props.fromSignup
          ? `
        width: 100vw;
        height: 100vh;
        height: -webkit-fill-available;
        max-height: 100vh;
        max-height: -webkit-fill-available;
        border-radius: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
      `
          : ''}
    }
  }

  &.MuiDialog-root {
    position: ${(props) => (props.fromSignup ? "relative" : "fixed")};
    backgroundColor: ${(props) => (props.fromSignup ? "transparent" : "none")};
    height: ${(props) => (props.fromSignup ? "-webkit-fill-available" : "auto")};
    
    @media (max-width: 600px) {
      ${(props) =>
        props.fromSignup
          ? `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh;
        height: -webkit-fill-available;
        overflow: hidden;
        overscroll-behavior: none;
      `
          : ''}
    }
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  .close-icon {
    cursor: pointer;
  }
`;

export const Title = styled.div`
    font-weight: 700;
  color: #0F0F0F;
  font-size: 20px;
  font-family: "DM Sans", sans-serif;
`

export const IconAndTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const StyledDialogContent = styled(DialogContent)`
  font-size: 16px;
  color: #565556;
  font-weight: 700;
  line-height: 20px;
  margin-top: 10px;
  @media (max-width: 600px) {
    ${(props) =>
      props.fromSignup
        ? `
      padding: 20px !important;
      margin-top: 0;
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      padding-bottom: calc(100px + env(safe-area-inset-bottom, 0px));
    `
        : ''}
  }
`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const VerifyButton = styled(Button)`
  background-color: #6f42c1 !important;
  color: white !important;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;

  &:hover {
    background-color: #5a379c !important;
  }
`;

export const Separator = styled.div`
    border: 1px solid #E1E1E1;
    flex-shrink: 0;
`